/**
 * @generated SignedSource<<d22347b85e654bcd536ba77400955d2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateRowInput = {
  clientMutationId?: string | null;
  rowId: string;
  text?: string | null;
};
export type GridQuestionEditor_updateRow_Mutation$variables = {
  input: UpdateRowInput;
};
export type GridQuestionEditor_updateRow_Mutation$data = {
  readonly updateRow: {
    readonly row: {
      readonly id: string;
      readonly text: string;
    } | null;
  } | null;
};
export type GridQuestionEditor_updateRow_Mutation = {
  response: GridQuestionEditor_updateRow_Mutation$data;
  variables: GridQuestionEditor_updateRow_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateRowPayload",
    "kind": "LinkedField",
    "name": "updateRow",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RowNode",
        "kind": "LinkedField",
        "name": "row",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "text",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GridQuestionEditor_updateRow_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GridQuestionEditor_updateRow_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7bd889276bb277b5a0f3fe1060fb5d15",
    "id": null,
    "metadata": {},
    "name": "GridQuestionEditor_updateRow_Mutation",
    "operationKind": "mutation",
    "text": "mutation GridQuestionEditor_updateRow_Mutation(\n  $input: UpdateRowInput!\n) {\n  updateRow(input: $input) {\n    row {\n      id\n      text\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "46c30f4f70715562e01a37ea2c621ae0";

export default node;
